export enum ServiceDeskArea {
    assistanceCard = 'assistanceCard',
    improvementCard = 'improvementCard',
    overview = 'overview',
    faq = 'faq',
    detailPageGeneral = 'detailPageGeneralQuestions',
    detailPageFirstSteps = 'detailPageFirstSteps',
    detailPageGroupManagement = 'detailPageGroupManagement',
}

export enum ServiceDeskAction {
    phoneNumberClicked = 'phoneNumberClicked',
    mailAdressClicked = 'mailAdressClicked',
    backToTopClicked = 'backToTopClicked',
    emailClicked = 'emailClicked',
    generalQuestionsCardClicked = 'generalQuestionsCardClicked',
    firstStepsCardClicked = 'firstStepsCardClicked',
    groupManagementCardClicked = 'groupManagementCardClicked',
    questionClicked = 'questionClicked',
}
